<template>
  <v-alert
    v-if="show"
    type="warning"
    prominent
    border="left"
    colored-border
    class="mb-4"
  >
    <strong>Ganhos pendentes de recebimento.</strong>
    Você possui ganhos disponíveis na sua rede, porém precisa conectar sua conta PagBank
    para receber os valores.
    <template v-if="showAction">
      <v-btn
        class="mt-2"
        small
        color="#e5183d"
        dark
        :to="{ name: 'bankAccount' }"
      >
        Conectar PagBank
      </v-btn>
    </template>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PagBankPremiumAlert",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
